import { render, staticRenderFns } from "./AssistantServiceList.vue?vue&type=template&id=4cd0a18c&scoped=true"
import script from "./AssistantServiceList.vue?vue&type=script&lang=js"
export * from "./AssistantServiceList.vue?vue&type=script&lang=js"
import style0 from "./AssistantServiceList.vue?vue&type=style&index=0&id=4cd0a18c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd0a18c",
  null
  
)

export default component.exports